import { getChannelSimpleList } from '@/apis/channel';
import {
  AccountType,
  ChannelSimpleInfo,
  ChannelSource,
  KosAccountInfo,
} from '@/interfaces/channel';
import { AccountStatus } from '@/interfaces/redbook';
import { atom } from 'jotai';

export interface AccountItem {
  relationId: string;
  name: string;
  avatar: string;
  accountType: AccountType;
  deleted: boolean;
  openStatus: string;
  adStatus: string;
  source: ChannelSource;
  receptionType?: string;
  status?: AccountStatus;
}

export const accountsDataAtom = atom<ChannelSimpleInfo[]>([]);
export const accountsMapDataAtom = atom<Record<string, AccountItem>>({});
export const accountsSourceMapAtom = atom<Record<ChannelSource, ChannelSimpleInfo[]>>({
  redbook: [],
  douyin: [],
});
export const accountsKosSourceMapAtom = atom<Record<ChannelSource, AccountItem[]>>({
  redbook: [],
  douyin: [],
});

export const accountsAtom = atom(
  (get) => ({
    accounts: get(accountsDataAtom),
    accountsMap: get(accountsMapDataAtom),
    accountsSourceMap: get(accountsSourceMapAtom),
    accountsKosSourceMap: get(accountsKosSourceMapAtom),
  }),
  (get, set) => {
    getChannelSimpleList().then((accounts) => {
      const { accountsMap, accountsKosSourceMap, accountsSourceMap } = accounts.reduce(
        (acc, account) => {
          const source = account.source;
          if (!acc.accountsSourceMap[source]) {
            acc.accountsSourceMap[source] = [];
          }
          if (!acc.accountsKosSourceMap[source]) {
            acc.accountsKosSourceMap[source] = [];
          }

          // source 对应 账号（主账号和 kos 账号 有层级）
          acc.accountsSourceMap[source].push(account);

          // 主账号
          const corpAccount: AccountItem = {
            ...account,
            accountType: 'CORP',
          };
          acc.accountsMap[account.relationId] = corpAccount;

          acc.accountsKosSourceMap[source].push(corpAccount);

          // kos 账号
          account.kosAccount?.forEach((kosAccount: KosAccountInfo) => {
            const kosAccountItem: AccountItem = {
              ...kosAccount,
              accountType: 'KOS',
              openStatus: account.openStatus,
              adStatus: account.adStatus,
              source: source,
            };
            acc.accountsMap[kosAccount.relationId] = kosAccountItem;
            acc.accountsKosSourceMap[source].push(kosAccountItem);
          });

          return acc;
        },
        {
          accountsMap: {} as Record<string, AccountItem>,
          accountsSourceMap: {} as Record<ChannelSource, ChannelSimpleInfo[]>,
          accountsKosSourceMap: {} as Record<ChannelSource, AccountItem[]>,
        },
      );

      set(accountsDataAtom, accounts);
      set(accountsMapDataAtom, accountsMap);
      set(accountsSourceMapAtom, accountsSourceMap);
      set(accountsKosSourceMapAtom, accountsKosSourceMap);
    });
  },
);
